import { UserData } from "../redux/type";

// function to format number
export const formatNumber = (num: any): string => {
  if (num === undefined || num === null || isNaN(num)) {
    return "0";
  }

  if (typeof num !== "number") {
    num = parseFloat(num);
    if (isNaN(num)) {
      return "0";
    }
  }

  const [integerPart, fractionalPart] = num.toString().split(".");
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  return fractionalPart
    ? `${formattedIntegerPart}.${fractionalPart.slice(0, 1)}`
    : formattedIntegerPart;
};

export const formatNumberCompact = (num: any) => {
  if (num === undefined) {
    return "0";
  }

  num = num.toString();

  // only 2 numbers after the decimal point
  num = parseFloat(num).toFixed(2);
  return num;
};

export function isValidTwitterUsername(username: string) {
  try {
    const usernameRegex = /^@[a-zA-Z0-9_]{1,15}$/;

    return usernameRegex.test(username);
  } catch (e) {
    return false;
  }
}

export function isAddressValid(address: string) {
  try {
    const addressRegex = /^0:[0-9a-fA-F]{64}$/;
    return addressRegex.test(address);
  } catch (e) {
    return false;
  }
}

export function shortenAddress(address: string) {
  if (!address) {
    return "";
  }
  return `${address.slice(0, 10)}...${address.slice(-6)}`;
}

export function isTelegramWebApp() {
  // @ts-ignore
  return typeof TelegramWebviewProxy !== "undefined";
}

export const calculateLifeTimeData = (user: UserData) => {
  const createdAt = new Date(user.createdAt);
  const lifelineTime = user.lifelineTime; // hours
  const lifelineTimeMs = lifelineTime * 3600 * 1000;

  const now = new Date();
  const remainingMs = lifelineTimeMs - (now.getTime() - createdAt.getTime());

  const remainingSeconds = Math.max(Math.floor(remainingMs / 1000), 0);

  return remainingSeconds;
};
